import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function SubscriptionChangeDate(props) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(null);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const saveDate = () => {
    handleClose();
    props.updateBillingDate(value);
  };

  return (
    <>
      <div>
        <span
          onClick={handleOpen}
          className="text-sm text-[#476EF8] font-medium hover:underline cursor-pointer"
        >
          Change
        </span>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="billing-modal-title"
          aria-describedby="billing-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              width: 400,
            }}
          >
            <h2
              id="billing-modal-title"
              className="text-lg font-semibold text-gray-800 mb-4"
            >
              Select New Billing Date
            </h2>

            <input
              type="date"
              onChange={(e) => setValue(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={handleClose}
                className="px-4 py-1.5 text-sm bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>

              <button
                onClick={saveDate}
                className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default SubscriptionChangeDate;
